export const quote = {
  // Page title and description
  pageTitle: 'اطلب',
  pageTitleHighlight: 'عرض سعر مجاني',
  pageDescription: 'صف مشروعك في بضع خطوات واحصل على تقدير مخصص',
  
  // Progress
  step: 'الخطوة',
  of: 'من',
  completed: 'مكتمل',
  securityNote: 'معلوماتك آمنة وسرية',
  
  // Step 1: Work Type
  step1Title: 'ما نوع الأعمال التي تريد القيام بها؟',
  step1Description: 'اختر نوعاً واحداً أو أكثر من الأعمال',
  workTypes: {
    interiorRenovation: 'تجديد داخلي',
    bathroom: 'حمام',
    kitchen: 'مطبخ',
    basement: 'قبو',
    atticConversion: 'تحويل العلية',
    extension: 'توسعة',
    facade: 'واجهة',
    roofing: 'سقف',
    flooring: 'أرضيات',
    painting: 'دهان',
    electricity: 'كهرباء',
    plumbing: 'سباكة',
    carpentry: 'نجارة',
    insulation: 'عزل',
    other: 'أخرى'
  },
  selectAtLeastOne: 'يرجى اختيار نوع واحد على الأقل من الأعمال',
  
  // Step 2: Housing Type
  step2Title: 'ما نوع السكن؟',
  step2Description: 'اختر نوع الممتلكات الخاصة بك',
  housingTypes: {
    apartment: 'شقة',
    house: 'منزل',
    studio: 'استوديو',
    duplex: 'دوبلكس',
    loft: 'لوفت',
    commercial: 'محل تجاري',
    office: 'مكتب'
  },
  selectHousingType: 'يرجى اختيار نوع السكن',
  
  // Step 3: Location
  step3Title: 'أين يقع المشروع؟',
  step3Description: 'أدخل الرمز البريدي والمدينة',
  postalCode: 'الرمز البريدي',
  postalCodePlaceholder: 'مثال: 1000',
  city: 'المدينة',
  cityPlaceholder: 'مثال: بروكسل',
  selectCity: 'اختر مدينة',
  invalidPostalCode: 'الرمز البريدي غير صالح',
  fillBothFields: 'يرجى ملء كلا الحقلين',
  
  // Step 4: Project Details
  step4Title: 'تفاصيل المشروع',
  step4Description: 'أخبرنا المزيد عن مشروعك',
  projectDescription: 'وصف المشروع',
  descriptionPlaceholder: 'صف مشروعك بالتفصيل: الأعمال المطلوبة، المساحة، التفضيلات...',
  estimatedBudget: 'الميزانية المقدرة',
  budgetPlaceholder: 'مثال: 10,000 - 15,000 يورو',
  desiredDeadline: 'الموعد النهائي المطلوب',
  deadlinePlaceholder: 'مثال: في غضون 3 أشهر',
  photos: 'صور (اختياري)',
  photosNote: 'إذا كان لديك صور، يمكنك إرسالها لاحقاً عبر البريد الإلكتروني',
  photosPlaceholder: 'سنطلب منك الصور لاحقاً إذا لزم الأمر',
  fillDescription: 'يرجى ملء وصف المشروع',
  
  // Step 5: Contact
  step5Title: 'معلومات الاتصال الخاصة بك',
  step5Description: 'الخطوة الأخيرة! كيف يمكننا الاتصال بك؟',
  fullName: 'الاسم الكامل',
  namePlaceholder: 'مثال: أحمد محمد',
  phone: 'الهاتف',
  phonePlaceholder: 'مثال: +32 123 45 67 89',
  email: 'البريد الإلكتروني',
  emailPlaceholder: 'مثال: ahmed.mohamed@email.com',
  dataProtection: 'بياناتك محمية',
  dataProtectionText: 'نستخدم معلوماتك فقط للاتصال بك بخصوص طلب عرض السعر الخاص بك.',
  required: '*',
  
  // Buttons
  next: 'التالي',
  previous: 'السابق',
  back: 'رجوع',
  submit: 'احصل على عرض السعر',
  submitting: 'جاري الإرسال...',
  
  // Success
  successTitle: 'شكراً لك!',
  successSubtitle: 'تم استلام طلبك بنجاح',
  successMessage: 'سنتصل بك في أقرب وقت ممكن لمناقشة مشروعك وتزويدك بعرض سعر مفصل.',
  successNextSteps: 'الخطوات التالية:',
  successStep1: 'سنراجع طلبك بعناية',
  successStep2: 'سنتصل بك خلال 24-48 ساعة',
  successStep3: 'سنحدد موعداً لزيارة الموقع إذا لزم الأمر',
  successStep4: 'ستتلقى عرض سعر مفصلاً ومخصصاً',
  backToHome: 'العودة إلى الصفحة الرئيسية',
  
  // Error messages
  errorSubmitting: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
};